$('.li-dropdown a').on('click', function(e){
  var parent = $(e.target).parent();
  parent.toggleClass('open');
});



// WEBPACK FOOTER //
// ./js/modules/_products.js